<template>
  <router-btn
    :text="isOnInportPage ? $t('servicesystem.common_objects.commonterms.cancel') : $t('servicesystem.common_objects.machine.import_machines')"
    :icon="isOnInportPage ? 'mdi-close' : 'mdi-upload'" :color="isOnInportPage ? 'error' : 'primary'" :disabled="false"
    :outlined="isOnInportPage" :textbtn="textbtn" :large="large" :small="small" @Press="action">
  </router-btn>
</template>

<script>
import RouterBtn from "@/components/Buttons/RouterBtn.vue";

export default {
  name: "ImportMachineBtn",
  props: ["large", "small", "textbtn"],
  components: { RouterBtn },

  data() {
    return {};
  },

  methods: {
    action() {
      var routeName = this.isOnInportPage ? 'MachineList' : 'ImportMachine';
      this.$router.push({ name: routeName });
    },
  },

  computed: {
    isOnInportPage() {
      return (this.$route.name == 'ImportMachine');
    }
  },

  watch: {},
};
</script>

<style lang="scss" scoped></style>
